import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class RmToleranceDTO {
    @ApiProperty()
    @IsNotEmpty({message:"rm tolerance id should not be empty"})
    @IsAlphanumeric()
    rmToleranceId?: number;

    @ApiProperty()
    @IsNotEmpty({message:"date should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    date: any;

    @ApiProperty()
    @IsNotEmpty({message:"loose shell should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    looseShell: number;

    
    @ApiProperty()
    @IsNotEmpty({message:"soft shell should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    softShell: number;

    
    @ApiProperty()
    @IsNotEmpty({message:"fungus should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    fungus: number;

    @ApiProperty()
    isActive: boolean;

    createdAt : Date;

   @ApiProperty()
   @IsOptional()
   @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
   createdUser :string ;

   updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;
  

  @ApiProperty()
  versionFlag : number;



}